<!--
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2023-04-20 19:40:27
 * @LastEditors: fangzhi fangzhi@vivo.com
-->
<!--  -->
<template>
  <v-os-popup :show="isShow" @close="close" :title="title" :footerShow="false" class="store-popup" container="body">
    <template v-slot:left>
      <span
        class="icon-tips"
        @click="showDesc"
        v-if="storeInfo && storeInfo.ruleTitle"
        tabindex="0"
        aria-label="查看门店服务详细规则"
      ></span>
    </template>
    <div v-if="modeSelect">
      <div class="location-box">
        <p class="tit">当前定位</p>
        <div class="location-info">
          <p class="info">{{ location }}</p>
          <p class="op" v-show="location" @click="goLocation">修改</p>
        </div>
      </div>
      <div class="store-dir">附近门店</div>
    </div>
    <div v-if="storeList.length">
      <template v-for="(store, index) in storeList">
        <div
          :class="['store-container', modeSelect ? 'select' : '']"
          tabindex="index"
          @click="selectItem(store)"
          :key="store.shopCode"
        >
          <v-icon
            :name="store.shopCode == selectedId ? 'selected' : 'unselected'"
            class="checkbox"
            v-if="modeSelect"
          ></v-icon>
          <div class="infos">
            <div class="name" v-text="store.shopName"></div>
            <div class="address" v-text="store.address"></div>
            <div class="detail">
              <span class="label" v-if="store.deliveryTime">{{ store.deliveryTime }}</span>
              <span class="label" v-if="store.selfPickUpTime">{{ store.selfPickUpTime }}</span>
              <span class="distance" v-text="`距您${formatDistance(store.distance)}`"></span>
            </div>
            <div class="distance-mark" v-if="modeSelect && index == 0">最近</div>
          </div>
        </div>
        <div class="line" :key="store.shopCode" v-if="!modeSelect && index < storeList.length - 1"></div>
      </template>
    </div>
    <div v-else class="empty-box">
      <v-empty type="content" description="附近暂无支持自提的门店"></v-empty>
    </div>
  </v-os-popup>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import env from '@/utils/clientEnv'
export default {
  name: 'StoreInfoPopup',
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '门店'
    },
    modeSelect: {
      type: Boolean,
      default: false
    },
    location: {
      type: String,
      default: ''
    },
    storeId: [String, Number],
    skuId: [String, Number],
    storeInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    //这里存放数据
    return {
      isLowAndroid: env.isLowAndroid,
      selectedId: 0
    }
  },
  //监听属性 类似于data概念
  computed: {
    storeList() {
      this.selectedId = this.storeInfo?.shopCode
      return this.storeInfo?.shopList || []
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    ...mapMutations('order-confirm', ['setPickUpId']),
    formatDistance(value) {
      if (value < 1000) {
        return value + 'm'
      } else {
        return (value / 1000).toFixed(1) + 'km'
      }
    },
    close() {
      this.$emit('close')
    },
    showDesc(e) {
      this.$emit('showDesc')
      this.savePreFocusElByEvent(e)
      this.$track({
        cfrom: '081|075|01|077',
        event_id: '081|075|01|077',
        sku_id: this.skuId
      })
    },
    goLocation() {
      this.$emit('showLocation')
    },
    selectItem(item) {
      this.selectedId = item.shopCode
      this['setPickUpId'](this.selectedId)
      this.$emit('selectFun', item)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="scss" src="./index.scss" />
<!-- <style lang="scss" scoped src="../../../index/dark-popup.scss"></style> -->
